import { FC, useState } from 'react';
import i18n from 'i18n';
import styles from './ConfirmationWrapper.module.scss';
import { Modal } from 'components/Modal/Modal';

export const ConfirmationWrapper: FC<{
  children: (showModal: () => void) => JSX.Element;
  description: string;
  onAction: () => void;
}> = ({ children, description, onAction }) => {
  const [open, setOpen] = useState(false);
  const hideModal = () => setOpen(false);
  const showModal = () => setOpen(true);
  const handleConfirm = () => {
    onAction();
    hideModal();
  };
  return (
    <>
      {open && (
        <Modal
          className={styles['confirmation-wrapper']}
          dismiss={hideModal}
          primaryButton={{
            title: i18n.t<string>('common.buttons.confirm'),
            callback: handleConfirm,
          }}
          secondaryButton={{
            title: i18n.t<string>('common.buttons.cancel'),
            callback: hideModal,
          }}
          backdrop='static'
        >
          <div className={styles.description}>{description}</div>
        </Modal>
      )}
      {children(showModal)}
    </>
  );
};
